/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const toggleCommunityActiveStatus = /* GraphQL */ `
  mutation ToggleCommunityActiveStatus($portfolioId: ID!, $propertyId: ID!) {
    toggleCommunityActiveStatus(
      portfolioId: $portfolioId
      propertyId: $propertyId
    ) {
      ctmhcId
      integrationId
      integrationType
      isActive
      legalEntityCommunityOwnerId
      name
      portfolio {
        id
        integrationId
        integrationType
        isActive
        name
      }
      displayId
      propertyId
    }
  }
`;
export const setResidentPermanentExclusion = /* GraphQL */ `
  mutation SetResidentPermanentExclusion(
    $id: ID!
    $isPermanentlyExcluded: Boolean!
  ) {
    setResidentPermanentExclusion(
      id: $id
      isPermanentlyExcluded: $isPermanentlyExcluded
    ) {
      id
      residentId
      firstName
      lastName
      siteAddress {
        addressLine1
        city
        lotUnit
        spaceCode
        state
        type
        zipCode
      }
      insuranceAdoption {
        description
        status
      }
      policyType
      community {
        ctmhcId
        integrationId
        integrationType
        isActive
        legalEntityCommunityOwnerId
        name
        portfolio {
          id
          integrationId
          integrationType
          isActive
          name
        }
        displayId
        propertyId
      }
      createdAt
      updatedAt
      email
      phoneNumber
      isCurrentResident
      isPermanentlyExcluded
      wasOptedIn
      moveInDate
      moveOutDate
      sos
      isNariWorkflowApplicable
      lease {
        addendumDate
        startDate
        endDate
        description
      }
      leaseRequirements {
        animalLiabilityLimit
        leaseLimit
        medicalPaymentsLimit
      }
      policyholderLocator
      coverages {
        id
        agencyAddress
        agencyEmail
        agencyName
        agencyPhoneNumber
        annualCost
        coverageDetails {
          occupancy
          manufacturer
          homeType
          modelYear
          animalLiabilityLimit
          blanketRentalResidentLiabilityLimit
          homeCoverageLimit
          otherStructuresLimit
          personalLiabilityLimit
          premisesLiabilityLimit
          personalPropertyLimit
          residentLiabilityLimit
          standardDeductibleLimit
          medicalPaymentsLimit
        }
        createdAt
        documents {
          id
          name
          description
        }
        events {
          id
          type
          date
          eventData {
            agencyName
            agencyAddress
            agencyPhoneNumber
            agencyEmail
            isInternalSale
            insuranceCarrierName
            isActive
            coverageDetails {
              occupancy
              manufacturer
              homeType
              modelYear
              animalLiabilityLimit
              blanketRentalResidentLiabilityLimit
              homeCoverageLimit
              otherStructuresLimit
              personalLiabilityLimit
              premisesLiabilityLimit
              personalPropertyLimit
              residentLiabilityLimit
              standardDeductibleLimit
              medicalPaymentsLimit
            }
            policyId
            policyDescription
            termEffectiveDate
            termEndDate
            annualCost
          }
        }
        insuranceCarrierName
        isActive
        isInternalSale
        policyCancellationEffectiveDate
        policyCancellationReason
        policyDescription
        policyEffectiveDate
        policyEndDate
        policyEndReason
        policyId
        policyIssuedDate
        policyStatus
        policyType
        updatedAt
        updatedBy
      }
      physicalMailNotificationEvents {
        id
        additionalData
        eventType
        eventDate
      }
    }
  }
`;
export const issueTLLForResident = /* GraphQL */ `
  mutation IssueTLLForResident($id: ID!) {
    issueTLLForResident(id: $id) {
      id
      residentId
      firstName
      lastName
      siteAddress {
        addressLine1
        city
        lotUnit
        spaceCode
        state
        type
        zipCode
      }
      insuranceAdoption {
        description
        status
      }
      policyType
      community {
        ctmhcId
        integrationId
        integrationType
        isActive
        legalEntityCommunityOwnerId
        name
        portfolio {
          id
          integrationId
          integrationType
          isActive
          name
        }
        displayId
        propertyId
      }
      createdAt
      updatedAt
      email
      phoneNumber
      isCurrentResident
      isPermanentlyExcluded
      wasOptedIn
      moveInDate
      moveOutDate
      sos
      isNariWorkflowApplicable
      lease {
        addendumDate
        startDate
        endDate
        description
      }
      leaseRequirements {
        animalLiabilityLimit
        leaseLimit
        medicalPaymentsLimit
      }
      policyholderLocator
      coverages {
        id
        agencyAddress
        agencyEmail
        agencyName
        agencyPhoneNumber
        annualCost
        coverageDetails {
          occupancy
          manufacturer
          homeType
          modelYear
          animalLiabilityLimit
          blanketRentalResidentLiabilityLimit
          homeCoverageLimit
          otherStructuresLimit
          personalLiabilityLimit
          premisesLiabilityLimit
          personalPropertyLimit
          residentLiabilityLimit
          standardDeductibleLimit
          medicalPaymentsLimit
        }
        createdAt
        documents {
          id
          name
          description
        }
        events {
          id
          type
          date
          eventData {
            agencyName
            agencyAddress
            agencyPhoneNumber
            agencyEmail
            isInternalSale
            insuranceCarrierName
            isActive
            coverageDetails {
              occupancy
              manufacturer
              homeType
              modelYear
              animalLiabilityLimit
              blanketRentalResidentLiabilityLimit
              homeCoverageLimit
              otherStructuresLimit
              personalLiabilityLimit
              premisesLiabilityLimit
              personalPropertyLimit
              residentLiabilityLimit
              standardDeductibleLimit
              medicalPaymentsLimit
            }
            policyId
            policyDescription
            termEffectiveDate
            termEndDate
            annualCost
          }
        }
        insuranceCarrierName
        isActive
        isInternalSale
        policyCancellationEffectiveDate
        policyCancellationReason
        policyDescription
        policyEffectiveDate
        policyEndDate
        policyEndReason
        policyId
        policyIssuedDate
        policyStatus
        policyType
        updatedAt
        updatedBy
      }
      physicalMailNotificationEvents {
        id
        additionalData
        eventType
        eventDate
      }
    }
  }
`;
export const getCtCoverageDetails = /* GraphQL */ `
  mutation GetCtCoverageDetails($policyLocator: String!, $residentId: ID!) {
    getCtCoverageDetails(
      policyLocator: $policyLocator
      residentId: $residentId
    ) {
      status
      addressMissmatch
      policyUnitAddress
      residentSiteAddress
      coverage {
        id
        agencyAddress
        agencyEmail
        agencyName
        agencyPhoneNumber
        annualCost
        coverageDetails {
          occupancy
          manufacturer
          homeType
          modelYear
          animalLiabilityLimit
          blanketRentalResidentLiabilityLimit
          homeCoverageLimit
          otherStructuresLimit
          personalLiabilityLimit
          premisesLiabilityLimit
          personalPropertyLimit
          residentLiabilityLimit
          standardDeductibleLimit
          medicalPaymentsLimit
        }
        createdAt
        documents {
          id
          name
          description
        }
        events {
          id
          type
          date
          eventData {
            agencyName
            agencyAddress
            agencyPhoneNumber
            agencyEmail
            isInternalSale
            insuranceCarrierName
            isActive
            coverageDetails {
              occupancy
              manufacturer
              homeType
              modelYear
              animalLiabilityLimit
              blanketRentalResidentLiabilityLimit
              homeCoverageLimit
              otherStructuresLimit
              personalLiabilityLimit
              premisesLiabilityLimit
              personalPropertyLimit
              residentLiabilityLimit
              standardDeductibleLimit
              medicalPaymentsLimit
            }
            policyId
            policyDescription
            termEffectiveDate
            termEndDate
            annualCost
          }
        }
        insuranceCarrierName
        isActive
        isInternalSale
        policyCancellationEffectiveDate
        policyCancellationReason
        policyDescription
        policyEffectiveDate
        policyEndDate
        policyEndReason
        policyId
        policyIssuedDate
        policyStatus
        policyType
        updatedAt
        updatedBy
      }
    }
  }
`;
export const saveCommunityConfiguration = /* GraphQL */ `
  mutation SaveCommunityConfiguration(
    $configuration: SaveCommunityConfigurationInput!
  ) {
    saveCommunityConfiguration(configuration: $configuration) {
      configuration {
        communities {
          addressLine1
          addressLine2
          city
          ctmhcId
          defaultAddendumDate
          displayId
          isActive
          name
          ownerClientId
          propertyId
          state
          zipCode
        }
        effectiveDate
        effectiveTimestamp
        owners {
          addressLine1
          addressLine2
          city
          clientId
          county
          id
          municipality
          name
          state
          zipCode
        }
        policyDefaults {
          limits {
            animalLiabilityLimit
            blanketRentalResidentLiabilityLimit
            medicalPaymentsLimit
            premisesLiabilityLimit
          }
          mgaFee
          operatorFee
          pricePerUnit
        }
        portfolio {
          addressLine1
          addressLine2
          city
          county
          id
          integrationId
          integrationType
          isActive
          name
          rentManagerLocations {
            glAccountId
            id
            name
          }
          rentManagerSettings {
            liveNotesEnabled
            shouldWriteDefaultUDFValues
          }
          state
          zipCode
        }
        states {
          localTaxes {
            cityName
            cityTaxRate
            countyName
            countyTaxRate
            otherLocalTaxes {
              name
              rate
            }
            ownerClientId
          }
          policyNumbers {
            ownerClientId
            policyNumber
          }
          stampingFee
          state
          stateTax
          surplusLinesTax
        }
        taxDefaults {
          otherFee {
            name
            rate
          }
          stampingFee
          state
          stateTax
          surplusLinesTax
        }
      }
      issues {
        code
        message
        path
        severity
      }
      ownerMappings {
        clientId
        id
      }
      saved
      status
    }
  }
`;
export const cancelTllCoverage = /* GraphQL */ `
  mutation CancelTllCoverage($coverageId: ID!, $residentId: ID!) {
    cancelTllCoverage(coverageId: $coverageId, residentId: $residentId) {
      id
      agencyAddress
      agencyEmail
      agencyName
      agencyPhoneNumber
      annualCost
      coverageDetails {
        occupancy
        manufacturer
        homeType
        modelYear
        animalLiabilityLimit
        blanketRentalResidentLiabilityLimit
        homeCoverageLimit
        otherStructuresLimit
        personalLiabilityLimit
        premisesLiabilityLimit
        personalPropertyLimit
        residentLiabilityLimit
        standardDeductibleLimit
        medicalPaymentsLimit
      }
      createdAt
      documents {
        id
        name
        description
      }
      events {
        id
        type
        date
        eventData {
          agencyName
          agencyAddress
          agencyPhoneNumber
          agencyEmail
          isInternalSale
          insuranceCarrierName
          isActive
          coverageDetails {
            occupancy
            manufacturer
            homeType
            modelYear
            animalLiabilityLimit
            blanketRentalResidentLiabilityLimit
            homeCoverageLimit
            otherStructuresLimit
            personalLiabilityLimit
            premisesLiabilityLimit
            personalPropertyLimit
            residentLiabilityLimit
            standardDeductibleLimit
            medicalPaymentsLimit
          }
          policyId
          policyDescription
          termEffectiveDate
          termEndDate
          annualCost
        }
      }
      insuranceCarrierName
      isActive
      isInternalSale
      policyCancellationEffectiveDate
      policyCancellationReason
      policyDescription
      policyEffectiveDate
      policyEndDate
      policyEndReason
      policyId
      policyIssuedDate
      policyStatus
      policyType
      updatedAt
      updatedBy
    }
  }
`;
export const addNewPortfolio = /* GraphQL */ `
  mutation AddNewPortfolio($portfolio: PortfolioInput!) {
    addNewPortfolio(portfolio: $portfolio)
  }
`;
export const addExternalCoverage = /* GraphQL */ `
  mutation AddExternalCoverage(
    $policy: ExternalPolicyDetailsInput!
    $residentId: ID!
    $documentIds: [ID!]
  ) {
    addExternalCoverage(
      policy: $policy
      residentId: $residentId
      documentIds: $documentIds
    ) {
      resident {
        id
        residentId
        firstName
        lastName
        siteAddress {
          addressLine1
          city
          lotUnit
          spaceCode
          state
          type
          zipCode
        }
        insuranceAdoption {
          description
          status
        }
        policyType
        community {
          ctmhcId
          integrationId
          integrationType
          isActive
          legalEntityCommunityOwnerId
          name
          portfolio {
            id
            integrationId
            integrationType
            isActive
            name
          }
          displayId
          propertyId
        }
        createdAt
        updatedAt
        email
        phoneNumber
        isCurrentResident
        isPermanentlyExcluded
        wasOptedIn
        moveInDate
        moveOutDate
        sos
        isNariWorkflowApplicable
        lease {
          addendumDate
          startDate
          endDate
          description
        }
        leaseRequirements {
          animalLiabilityLimit
          leaseLimit
          medicalPaymentsLimit
        }
        policyholderLocator
        coverages {
          id
          agencyAddress
          agencyEmail
          agencyName
          agencyPhoneNumber
          annualCost
          coverageDetails {
            occupancy
            manufacturer
            homeType
            modelYear
            animalLiabilityLimit
            blanketRentalResidentLiabilityLimit
            homeCoverageLimit
            otherStructuresLimit
            personalLiabilityLimit
            premisesLiabilityLimit
            personalPropertyLimit
            residentLiabilityLimit
            standardDeductibleLimit
            medicalPaymentsLimit
          }
          createdAt
          documents {
            id
            name
            description
          }
          events {
            id
            type
            date
            eventData {
              agencyName
              agencyAddress
              agencyPhoneNumber
              agencyEmail
              isInternalSale
              insuranceCarrierName
              isActive
              coverageDetails {
                occupancy
                manufacturer
                homeType
                modelYear
                animalLiabilityLimit
                blanketRentalResidentLiabilityLimit
                homeCoverageLimit
                otherStructuresLimit
                personalLiabilityLimit
                premisesLiabilityLimit
                personalPropertyLimit
                residentLiabilityLimit
                standardDeductibleLimit
                medicalPaymentsLimit
              }
              policyId
              policyDescription
              termEffectiveDate
              termEndDate
              annualCost
            }
          }
          insuranceCarrierName
          isActive
          isInternalSale
          policyCancellationEffectiveDate
          policyCancellationReason
          policyDescription
          policyEffectiveDate
          policyEndDate
          policyEndReason
          policyId
          policyIssuedDate
          policyStatus
          policyType
          updatedAt
          updatedBy
        }
        physicalMailNotificationEvents {
          id
          additionalData
          eventType
          eventDate
        }
      }
      alreadyAddedCoverageId
      alreadyAddedCoverageStatus
      cancelledCoverage {
        id
        agencyAddress
        agencyEmail
        agencyName
        agencyPhoneNumber
        annualCost
        coverageDetails {
          occupancy
          manufacturer
          homeType
          modelYear
          animalLiabilityLimit
          blanketRentalResidentLiabilityLimit
          homeCoverageLimit
          otherStructuresLimit
          personalLiabilityLimit
          premisesLiabilityLimit
          personalPropertyLimit
          residentLiabilityLimit
          standardDeductibleLimit
          medicalPaymentsLimit
        }
        createdAt
        documents {
          id
          name
          description
        }
        events {
          id
          type
          date
          eventData {
            agencyName
            agencyAddress
            agencyPhoneNumber
            agencyEmail
            isInternalSale
            insuranceCarrierName
            isActive
            coverageDetails {
              occupancy
              manufacturer
              homeType
              modelYear
              animalLiabilityLimit
              blanketRentalResidentLiabilityLimit
              homeCoverageLimit
              otherStructuresLimit
              personalLiabilityLimit
              premisesLiabilityLimit
              personalPropertyLimit
              residentLiabilityLimit
              standardDeductibleLimit
              medicalPaymentsLimit
            }
            policyId
            policyDescription
            termEffectiveDate
            termEndDate
            annualCost
          }
        }
        insuranceCarrierName
        isActive
        isInternalSale
        policyCancellationEffectiveDate
        policyCancellationReason
        policyDescription
        policyEffectiveDate
        policyEndDate
        policyEndReason
        policyId
        policyIssuedDate
        policyStatus
        policyType
        updatedAt
        updatedBy
      }
      residentStatusChanged
    }
  }
`;
export const addCovertreeCoverage = /* GraphQL */ `
  mutation AddCovertreeCoverage($policyLocator: ID!, $residentId: ID!) {
    addCovertreeCoverage(
      policyLocator: $policyLocator
      residentId: $residentId
    ) {
      resident {
        id
        residentId
        firstName
        lastName
        siteAddress {
          addressLine1
          city
          lotUnit
          spaceCode
          state
          type
          zipCode
        }
        insuranceAdoption {
          description
          status
        }
        policyType
        community {
          ctmhcId
          integrationId
          integrationType
          isActive
          legalEntityCommunityOwnerId
          name
          portfolio {
            id
            integrationId
            integrationType
            isActive
            name
          }
          displayId
          propertyId
        }
        createdAt
        updatedAt
        email
        phoneNumber
        isCurrentResident
        isPermanentlyExcluded
        wasOptedIn
        moveInDate
        moveOutDate
        sos
        isNariWorkflowApplicable
        lease {
          addendumDate
          startDate
          endDate
          description
        }
        leaseRequirements {
          animalLiabilityLimit
          leaseLimit
          medicalPaymentsLimit
        }
        policyholderLocator
        coverages {
          id
          agencyAddress
          agencyEmail
          agencyName
          agencyPhoneNumber
          annualCost
          coverageDetails {
            occupancy
            manufacturer
            homeType
            modelYear
            animalLiabilityLimit
            blanketRentalResidentLiabilityLimit
            homeCoverageLimit
            otherStructuresLimit
            personalLiabilityLimit
            premisesLiabilityLimit
            personalPropertyLimit
            residentLiabilityLimit
            standardDeductibleLimit
            medicalPaymentsLimit
          }
          createdAt
          documents {
            id
            name
            description
          }
          events {
            id
            type
            date
            eventData {
              agencyName
              agencyAddress
              agencyPhoneNumber
              agencyEmail
              isInternalSale
              insuranceCarrierName
              isActive
              coverageDetails {
                occupancy
                manufacturer
                homeType
                modelYear
                animalLiabilityLimit
                blanketRentalResidentLiabilityLimit
                homeCoverageLimit
                otherStructuresLimit
                personalLiabilityLimit
                premisesLiabilityLimit
                personalPropertyLimit
                residentLiabilityLimit
                standardDeductibleLimit
                medicalPaymentsLimit
              }
              policyId
              policyDescription
              termEffectiveDate
              termEndDate
              annualCost
            }
          }
          insuranceCarrierName
          isActive
          isInternalSale
          policyCancellationEffectiveDate
          policyCancellationReason
          policyDescription
          policyEffectiveDate
          policyEndDate
          policyEndReason
          policyId
          policyIssuedDate
          policyStatus
          policyType
          updatedAt
          updatedBy
        }
        physicalMailNotificationEvents {
          id
          additionalData
          eventType
          eventDate
        }
      }
      alreadyAddedCoverageId
      alreadyAddedCoverageStatus
      cancelledCoverage {
        id
        agencyAddress
        agencyEmail
        agencyName
        agencyPhoneNumber
        annualCost
        coverageDetails {
          occupancy
          manufacturer
          homeType
          modelYear
          animalLiabilityLimit
          blanketRentalResidentLiabilityLimit
          homeCoverageLimit
          otherStructuresLimit
          personalLiabilityLimit
          premisesLiabilityLimit
          personalPropertyLimit
          residentLiabilityLimit
          standardDeductibleLimit
          medicalPaymentsLimit
        }
        createdAt
        documents {
          id
          name
          description
        }
        events {
          id
          type
          date
          eventData {
            agencyName
            agencyAddress
            agencyPhoneNumber
            agencyEmail
            isInternalSale
            insuranceCarrierName
            isActive
            coverageDetails {
              occupancy
              manufacturer
              homeType
              modelYear
              animalLiabilityLimit
              blanketRentalResidentLiabilityLimit
              homeCoverageLimit
              otherStructuresLimit
              personalLiabilityLimit
              premisesLiabilityLimit
              personalPropertyLimit
              residentLiabilityLimit
              standardDeductibleLimit
              medicalPaymentsLimit
            }
            policyId
            policyDescription
            termEffectiveDate
            termEndDate
            annualCost
          }
        }
        insuranceCarrierName
        isActive
        isInternalSale
        policyCancellationEffectiveDate
        policyCancellationReason
        policyDescription
        policyEffectiveDate
        policyEndDate
        policyEndReason
        policyId
        policyIssuedDate
        policyStatus
        policyType
        updatedAt
        updatedBy
      }
      residentStatusChanged
    }
  }
`;
export const addCoverageEvent = /* GraphQL */ `
  mutation AddCoverageEvent(
    $coverageEvent: CoverageEventInput!
    $residentId: ID!
    $coverageId: ID!
  ) {
    addCoverageEvent(
      coverageEvent: $coverageEvent
      residentId: $residentId
      coverageId: $coverageId
    ) {
      id
      residentId
      firstName
      lastName
      siteAddress {
        addressLine1
        city
        lotUnit
        spaceCode
        state
        type
        zipCode
      }
      insuranceAdoption {
        description
        status
      }
      policyType
      community {
        ctmhcId
        integrationId
        integrationType
        isActive
        legalEntityCommunityOwnerId
        name
        portfolio {
          id
          integrationId
          integrationType
          isActive
          name
        }
        displayId
        propertyId
      }
      createdAt
      updatedAt
      email
      phoneNumber
      isCurrentResident
      isPermanentlyExcluded
      wasOptedIn
      moveInDate
      moveOutDate
      sos
      isNariWorkflowApplicable
      lease {
        addendumDate
        startDate
        endDate
        description
      }
      leaseRequirements {
        animalLiabilityLimit
        leaseLimit
        medicalPaymentsLimit
      }
      policyholderLocator
      coverages {
        id
        agencyAddress
        agencyEmail
        agencyName
        agencyPhoneNumber
        annualCost
        coverageDetails {
          occupancy
          manufacturer
          homeType
          modelYear
          animalLiabilityLimit
          blanketRentalResidentLiabilityLimit
          homeCoverageLimit
          otherStructuresLimit
          personalLiabilityLimit
          premisesLiabilityLimit
          personalPropertyLimit
          residentLiabilityLimit
          standardDeductibleLimit
          medicalPaymentsLimit
        }
        createdAt
        documents {
          id
          name
          description
        }
        events {
          id
          type
          date
          eventData {
            agencyName
            agencyAddress
            agencyPhoneNumber
            agencyEmail
            isInternalSale
            insuranceCarrierName
            isActive
            coverageDetails {
              occupancy
              manufacturer
              homeType
              modelYear
              animalLiabilityLimit
              blanketRentalResidentLiabilityLimit
              homeCoverageLimit
              otherStructuresLimit
              personalLiabilityLimit
              premisesLiabilityLimit
              personalPropertyLimit
              residentLiabilityLimit
              standardDeductibleLimit
              medicalPaymentsLimit
            }
            policyId
            policyDescription
            termEffectiveDate
            termEndDate
            annualCost
          }
        }
        insuranceCarrierName
        isActive
        isInternalSale
        policyCancellationEffectiveDate
        policyCancellationReason
        policyDescription
        policyEffectiveDate
        policyEndDate
        policyEndReason
        policyId
        policyIssuedDate
        policyStatus
        policyType
        updatedAt
        updatedBy
      }
      physicalMailNotificationEvents {
        id
        additionalData
        eventType
        eventDate
      }
    }
  }
`;
